var app = app || {};
(function ($) {
    $.extend(app, {
        consts: {
            grid: {
                defaultPageSize: 10,
                defaultPageSizes: [5, 10, 25, 50, 100, 250, 500],
                pagerSize: 11
            },
            userManagement: {
                defaultAdminUserName: "admin"
            },
            contentTypes: {
                formUrlEncoded: "application/x-www-form-urlencoded; charset=UTF-8",
                applicationJson: "application/json"
            },
            friendshipState: {
                accepted: 1,
                blocked: 2
            },
            notification: {
                displayCap: 99,
                limit: 20,
                textCharacterLimit: 150
            },
            alternateSaveType: {
                saveAndEdit: 1,
                saveAndCreate: 2,
                saveAndApprove: 4,
                saveAndQueue: 8
            },
            keyboardKey: {
                control: "Control",
                alt: "Alt",
                shift: "Shift",
                escape: "Escape",
                tab: "Tab",
                capsLock: "CapsLock",
                f1: "F1",
                f2: "F2",
                f3: "F3",
                f4: "F4",
                f5: "F5",
                f6: "F6",
                f7: "F7",
                f8: "F8",
                f9: "F9",
                f10: "F10",
                f11: "F11",
                f12: "F12",
                printScreen: "PrintScreen",
                scrollLock: "ScrollLock",
                pause: "Pause",
                numLock: "NumLock",
                backspace: "Backspace",
                space: " ",
                insert: "Insert",
                delete: "Delete",
                home: "Home",
                end: "End",
                pageUp: "PageUp",
                pageDown: "PageDown",
                enter: "Enter",
                meta: "Meta",
                arrowUp: "ArrowUp",
                arrowDown: "ArrowDown",
                arrowLeft: "ArrowLeft",
                arrowRight: "ArrowRight"
            }
        }
    });
})(jQuery);
